











































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Button from '@/components/Button.vue';
import Translation from '@/components/i18n/Translation.vue';
import { Getter, namespace } from 'vuex-class';
import Loader from '@/components/Loader.vue';
import Logo from '@/components/Logo.vue';
import User from '@/types/auth/User';
import RegisterStepOne from '@/views/auth/register/RegisterStepOne.vue';
import RegisterStepTwo from '@/views/auth/register/RegisterStepTwo.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';

const AuthModule = namespace('auth');

@Component({
  components: {
    NewTranslation,
    RegisterStepTwo,
    RegisterStepOne,
    NavBar,
    TabBar,
    Button,
    Translation,
    Loader,
    Logo,
  },
})
export default class RegisterView extends Vue {
  @Prop(Object)
  private pagedata!: any;

  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  @AuthModule.Action('registerUser')
  public registerUser!: any;

  @Getter
  public loggedInUser!: boolean;

  public user: User = new User();

  public stepsAvailable: number = 2;

  public currentStep: number = 1;

  public registrationIsLoading: boolean = false;

  public previousStep(): void {
    if (this.currentStep === 1) {
    }

    this.currentStep = this.currentStep - 1;
  }

  public nextStep(): void {
    if (this.currentStep === this.stepsAvailable) {
      return;
    }

    if (this.currentStep === 1 && this.user.validateStepOne()) {
      this.currentStep = this.currentStep + 1;
    }
  }

  public async submit(): Promise<void> {
    if (this.currentStep !== 2 || !this.user.validateStepTwo()) {
      return;
    }

    this.registrationIsLoading = true;

    try {
      this.user.email = this.user.email.toLowerCase();
      await this.registerUser(this.user);
      await this.$router.push({ name: 'registerConfirmation' });
    } catch (e) {
      console.log('Failed to register user', e);

      if (e && e.response && e.response.status === 422) {
        this.user.errors = e.response.data;
        this.showError(
          i18next.t('register.requestError.dialog.validation.title'),
          i18next.t('register.requestError.dialog.validation.body')
        );
      } else {
        this.showError(
          i18next.t('register.requestError.dialog.unknown.title'),
          i18next.t('register.requestError.dialog.unknown.body')
        );
      }
    } finally {
      this.registrationIsLoading = false;
    }
  }

  public showError(title: string, message: string): void {
    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        title,
        message,
      },
    });
  }
}
